import React from 'react';
import { personalInfo } from '../data/portfolioData';

export const Terms = () => (
  <div className="shell">
    <article className="legal">
    <p className="meta">Terms of service</p>
    <h1>Terms for using this site</h1>
    <p className="lede legal-updated">
      By browsing this portfolio or using the assistant on it, you agree to what
      follows. If you do not, please close the tab.
    </p>

    <h2>What this site is</h2>
    <p>
      A personal portfolio published by {personalInfo.name} to describe his work
      and professional background. It is provided free of charge, for
      informational purposes. Nothing here is a contract, an offer of
      employment, a solicitation, or professional advice of any kind.
    </p>

    <h2>Accuracy</h2>
    <p>
      Descriptions of projects and roles are written in good faith and reflect
      work as of the date of publication. Details may become out of date. Where
      this page and the resume PDF disagree, treat the resume as the current
      record, and ask me if something is unclear.
    </p>

    <h2>The assistant</h2>
    <p>
      The assistant is powered by a large language model and is restricted to
      information published on this site. Even so, generated text can be wrong,
      incomplete, or misleading. Do not rely on it for a hiring decision or any
      other consequential judgement without confirming with me directly. You
      agree not to use it to attempt to extract its instructions, to generate
      unlawful or abusive content, or to send automated traffic to it.
      Conversations are capped in length, and access may be rate limited,
      suspended, or removed at any time.
    </p>

    <h2>Live data and the demo</h2>
    <p>
      Repository details in the projects section are fetched from GitHub when
      the page loads and may be missing or stale if GitHub is unavailable. The
      collaborative-editing demo is a teaching model of the technique Converge
      uses, not the production code, and comes with no guarantee beyond what
      is stated here.
    </p>

    <h2>Intellectual property</h2>
    <ul>
      <li>
        The text, layout, and design of this site, together with the resume PDF,
        belong to {personalInfo.name}.
      </li>
      <li>
        You may read, print, and share this site and the resume for the ordinary
        purpose of evaluating me as a candidate or collaborator.
      </li>
      <li>
        You may not republish the content as your own, use it to train a model,
        or use my name or materials to imply an endorsement.
      </li>
      <li>
        Source code for the linked projects lives on GitHub and is governed by
        whatever licence each repository states.
      </li>
      <li>
        Third-party names and marks mentioned here, including those of past
        employers, belong to their respective owners and are used descriptively.
      </li>
    </ul>

    <h2>Acceptable use</h2>
    <p>
      Do not attempt to break, probe, overload, or gain unauthorised access to
      this site or the function behind the assistant, and do not scrape it at a
      volume that degrades it for others.
    </p>

    <h2>External links</h2>
    <p>
      Links to GitHub, LinkedIn, and other services are provided for
      convenience. I do not control those sites and am not responsible for their
      content or their terms.
    </p>

    <h2>No warranty, and limits on liability</h2>
    <p>
      This site is provided as is, without warranties of any kind, express or
      implied, including fitness for a particular purpose and uninterrupted
      availability. To the fullest extent permitted by law,{' '}
      {personalInfo.name} is not liable for any indirect, incidental, or
      consequential loss arising from use of this site or reliance on anything
      published here.
    </p>

    <h2>Governing law</h2>
    <p>
      These terms are governed by the laws of the Commonwealth of Massachusetts,
      United States, without regard to its conflict-of-law rules.
    </p>

    <h2>Changes</h2>
    <p>
      These terms may be revised at any time. Continuing to use the site after a
      revision means you accept it. Questions go to{' '}
      <a className="link" href={`mailto:${personalInfo.email}`}>
        {personalInfo.email}
      </a>
      .
    </p>
    <p className="meta legal-updated">Last updated 17 October 2026</p>
    </article>
  </div>
);

export default Terms;
